import {defineMessages} from 'react-intl';

export default defineMessages({
	wishlistBookmarkTitle: {
		id: 'header.wishlist',
		defaultMessage: 'Wishlist',
	},
});
